export enum DeliveryConstraintEnum {
  PROGRESS_BAR = "PROGRESS_BAR",
  TEXT_VERSION = "TEXT_VERSION",
}

export enum OrderLayoutOptionsEnum {
  reference = "reference",
  clientName = "clientName",
  id = "id",
  version = "version",
  amount = "amount",
  lastUpdated = "lastUpdated",
  source = "source",
}

export const OrderLayoutOptionsObj = Object.values(
  OrderLayoutOptionsEnum,
).reduce((acc, key) => {
  acc[key as OrderLayoutOptionsEnum] = key
  return acc
}, {} as Record<OrderLayoutOptionsEnum, string>)

export const orderLayoutOptionsList = Object.values(
  OrderLayoutOptionsObj,
) as OrderLayoutOptionsEnum[]

/* config form constants */
export const orderLayoutFormFields = {
  topLeft: "topLeft",
  topRight: "topRight",
  bottomLeft: "bottomLeft",
  bottomRight: "bottomRight",
  deliveryConstraint: "deliveryConstraint",
}

export const defaultOrderLayoutFormValue = {
  id: 218,
  topLeft: null,
  topRight: null,
  bottomLeft: null,
  bottomRight: null,
  deliveryConstraint: DeliveryConstraintEnum.PROGRESS_BAR,
}
